var YepNopeMessagePage = require("app/AppLayout/YepNopeMessagePage"),
    config             = require("app/config"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    get                = require("object-path").get,
    icons              = require("app/theme/icons"),
    kind               = require("enyo/kind"),
    quickMacroize      = require("enyo/macroize").quickMacroize;

module.exports = kind(/** @lends  app.UpgradeRequiredPage.UpgradeCtaPageView.prototype */ {

    /**
     * @private
     */
    name: "app-upgrade-required-page-upgrade-cta-page-view",

    /**
     * @private
     */
    kind: YepNopeMessagePage,

    /**
     * @private
     */
    classes: "app-upgrade-required-page-upgrade-cta-page-view",

    /**
     * @private
     */
    handlers: {
        onMessageYepButtonTap:  "onMessageYepButtonTap",
        onMessageNopeButtonTap: "onMessageNopeButtonTap"
    },

    /**
     * @private
     */
    observers: {
        update: ["state"]
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.yepButton.set("icon", icons["app.UpgradeRequiredPage.UpgradeCtaPageView.yepButton"]);
            this.$.message.$.nopeButton.set("icon", icons["app.UpgradeRequiredPage.UpgradeCtaPageView.nopeButton"]);
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var state       = this.state || {},
            i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.title"));
        $message.$.body.set("content", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.body", {
            mediaType: get(state, "params.mediaType", null) || ""
        }));
        $message.$.yepButton.set("caption", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.UpgradeButton.caption"));
        $message.$.yepButton.set("tooltip", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.UpgradeButton.tooltip"));
        $message.$.nopeButton.set("caption", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.CancelButton.caption"));
        $message.$.nopeButton.set("tooltip", i18nService.getString("app.UpgradeRequiredPage.UpgradeCtaPageView.CancelButton.tooltip"));
    },

    /**
     * Go to the upgrade page
     *
     * @private
     */
    onMessageYepButtonTap: function() {
        var i18nService       = this.app.$.i18nService,
            language          = i18nService.get("language"),
            upgradeAccountUrl = get(config, "upgradeAccountUrl." + language, null);

        if (upgradeAccountUrl) {
            window.location = quickMacroize(upgradeAccountUrl, {
                successUrl: encodeURIComponent(window.location.href)
            });
        }
    },

    /**
     * Navigate back to the previous route.
     *
     * @private
     */
    onMessageNopeButtonTap: function() {
        this.app.$.router.back();
    }

});
